// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Skeleton } from "@crehana/ui";
import cn from "clsx";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DiplomaCardSkeleton = function DiplomaCardSkeleton(_ref) {
  var className = _ref.className,
    isDark = _ref.isDark;
  return /*#__PURE__*/_jsxs("div", {
    className: cn('w-full flex flex-col rounded-5 overflow-hidden', isDark ? 'bg-base-lighter-16' : 'bg-white shadow-tooltip', className),
    children: [/*#__PURE__*/_jsx(Skeleton, {
      className: "flex-shrink-0 w-full h-160",
      isDark: isDark
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col w-full p-16",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        className: "w-3/4 h-16 mb-8",
        isDark: isDark
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "w-full h-20 mb-2",
        isDark: isDark
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "w-1/3 h-20 mb-8",
        isDark: isDark
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "w-3/4 h-20 mb-12",
        isDark: isDark
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "w-full h-48 rounded-5",
        isDark: isDark
      })]
    })]
  });
};
export default DiplomaCardSkeleton;